export default __webpack_public_path__ + "static/media/Error_404.3775f208.png";